import styles from "./ValidationMessage.module.css"

export default function ValidationMessage({show, message}) {
  return show ? <span className={styles["validation-message"]}>{message}</span> : <span/>
}